"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const theme_provider_1 = require("../theme-provider");
const text_1 = require("../text");
const StyledCharacterCounter = theme_provider_1.styled.span.withConfig({ displayName: "StyledCharacterCounter", componentId: "sc-paxn5p" }) `
	display: flex;
	justify-content: flex-end;
`;
exports.CharacterCounter = ({ maxLength, value = '' }) => (React.createElement(StyledCharacterCounter, { "aria-hidden": true },
    React.createElement(text_1.Text, { color: text_1.TextColor.inherit, appearance: text_1.TextAppearance.copy100 },
        value.length,
        "/",
        maxLength)));
